import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { PromotionsService } from '../../promotions.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-loyalty-rewards-configuration',
  templateUrl: './loyalty-rewards-configuration.component.html',
  styleUrls: ['./loyalty-rewards-configuration.component.scss'],
  providers: [CurrencyPipe]
})
export class LoyaltyRewardsConfigurationComponent extends FeaturesBaseComponent implements OnInit, OnDestroy, OnChanges {
  @Input() loyalityRewardsData;
  @Input() codeGroups: [];
  @Input() tiers: [];
  @Input() countries: any[];
  isLoyaltyRewardsVisible: boolean = true;
  isLoyaltyEditVisible: boolean = false;
  rowSelection: string;
  searchValue;
  showEditPromotion: boolean = false;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  loyaltyRewardsForm: FormGroup;
  providers: any;
  loyaltyId: any;
  loyaltyRewardDetail: any;
  countriesList: any = [];
  submitLabel: string;
  formAction: string;
  isFormUpdate: boolean = false;
  codeGroupControl = new FormControl();
  tierControl = new FormControl('');
  pointsControl = new FormControl('');
  countryControl = new FormControl('');
  amountControl = new FormControl('')
  @ViewChild('allSelected') private allSelected: MatOption;
  selectedcountriesList: any;
  applicableCountries: any;
  columnDefs: any;

  constructor(private currencyPipe: CurrencyPipe, private fb: FormBuilder, private router: Router, private dialog : MatDialog, private promotionService: PromotionsService) {
    super();
    this.isLoyaltyRewardsVisible = true;
    this.isLoyaltyEditVisible = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['countries']) {
      this.countries = changes['countries'].currentValue;
    }
    if (changes['tiers']) {
      this.tiers = changes['tiers'].currentValue;
    }
    this.countriesList = []
    this.countries.forEach(element => {
      this.countriesList.push(element.countryName)
    });

  }
  ngOnInit(): void {
    this.initiateForm();
  }


  initiateForm = () => {
    this.loyaltyRewardsForm = new FormGroup({
      codeGroup: this.codeGroupControl,
      tier: this.tierControl,
      points: this.pointsControl,
      country: this.countryControl,
      amount: this.amountControl
    })
  }

  get f() {
    return this.loyaltyRewardsForm.controls;
  }

  return() {
    this.isLoyaltyEditVisible = false;
    this.isLoyaltyRewardsVisible = true;
    this.loyaltyRewardsForm.reset();
    return
  }

  editPromotions() {
    this.formAction = 'pages.placeholders.Edit';
    this.submitLabel = 'pages.placeholders.Update';
    this.isFormUpdate = true;
    this.loyaltyId = this.selectedRows[0].loyaltyId;
    if (this.loyaltyId && this.loyaltyId) {
      this.promotionService.getLoyaltyRewardsDataById(this.loyaltyId)
        .subscribe(res => {
          this.loyaltyRewardDetail = res['data']
          this.fillLoyaltyForm(this.loyaltyRewardDetail)
        }
        );
      this.isLoyaltyEditVisible = true;
      this.isLoyaltyRewardsVisible = false;
    }
  }

  deletePromotion() {
    this.loyaltyId = this.selectedRows[0].loyaltyId;
    if (this.loyaltyId && this.loyaltyId) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.areYouSureToDelete',
          buttonText: {
            ok: 'pages.placeholders.Yes',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.promotionService.deleteLoyaltyRewardsDataById(this.loyaltyId)
            .subscribe(res => {
              this.showEditPromotion = false
              this.loyalityRewardsData = this.loyalityRewardsData.filter(x => x.loyaltyId != this.loyaltyId);
              this.toastrService.success('Deleted successfully', 'Success');
            }
            );
        }
      });
    }
  }

  addPromotionConfig() {
    this.formAction = 'pages.placeholders.Add';
    this.submitLabel = 'pages.placeholders.Save';
    this.isFormUpdate = false;
    this.isLoyaltyEditVisible = true;
    this.isLoyaltyRewardsVisible = false;
  }

  fillLoyaltyForm(loyaltyRewardDetail: any) {

    this.loyaltyRewardsForm.get('codeGroup').setValue(loyaltyRewardDetail.codeGroup)
    this.loyaltyRewardsForm.get('tier').setValue(loyaltyRewardDetail.tier)
    this.loyaltyRewardsForm.get('points').setValue(loyaltyRewardDetail.pointsAccumulated)

    let _applicableCountries: any = [];
    loyaltyRewardDetail.applicableCountries.forEach(element => {
      _applicableCountries.push(element.trim())
      if (loyaltyRewardDetail.applicableCountries.length == _applicableCountries.length) {
        this.loyaltyRewardsForm.get('country').setValue(_applicableCountries)
        this.applicableCountries = _applicableCountries
      }
    });
    this.loyaltyRewardsForm.get('amount').setValue(loyaltyRewardDetail.amountOfRecharge)
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  //loyaltyId
  loyalityRewardsColumnDef: any = [
    { field: 'loyaltyId', headerName: 'loyaltyId', width: 0, hide: true, sort: "desc" },
    { field: "null", headerName: "Action", checkboxSelection: true, width: 120 },
    {
      field: 'amountOfRecharge', headerName: 'Amount', width: 195, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)
      }
    },
    { field: 'pointsAccumulated', headerName: 'Target Points', width: 195 },
    { field: 'codeGroup', headerName: 'Code Group', width: 195 },
    { field: 'tier', headerName: 'Tier', width: 180 },
    { field: 'applicableCountries', headerName: 'Country', width: 195 }
  ]

  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: 'Loyalty-Rewards.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      } else if (cellParams && cellParams.column.colId === 'eventDttm') {
        return this.currencyPipe.transform(cellParams.value); //apply your timestamp formatter 
      }
      else return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.showEditPromotion = true;
      return
    }
    this.showEditPromotion = false;
    //edit-loyality
  }

  onLoyaltyFormSubmit() {
    //;
    if (!this.loyaltyRewardsForm.valid) {
      return;
    }

    if (this.isFormUpdate) {

      let selectdlist = this.loyaltyRewardsForm.get('country').value

      this.promotionService.getCountryNames(this.loyaltyRewardsForm.get('codeGroup').value, this.loyaltyRewardsForm.get('tier').value).subscribe(res => {
        let resData: any = res;
        this.selectedcountriesList = [];
        if (resData.httpcode == 200) {
          resData = resData.data;
          resData.forEach(element => {
            this.selectedcountriesList.push(element);
          });

          let _countries: any = [];
          let _countriesfrom: any = [];

          selectdlist.forEach(element => {

            if (element != 0) {

              if (this.selectedcountriesList.indexOf(element) !== -1) {
                if (this.applicableCountries.indexOf(element) !== -1) {

                } else {
                  _countriesfrom.push(element)
                }
              }
              _countries.push(element)

            }
          });
          if (_countriesfrom.length > 0) {
            this.toastrService.error('Loyalty Rewards are already configured for Countries below:  ' + _countriesfrom, 'Error', {
              timeOut: 3000,
            });
            //this.editPromotions();
            return;
          }


          let _selectedRow = this.selectedRows[0];
          if (_selectedRow.loyaltyId == this.loyaltyId) {
            let params = {
              "amountOfRecharge": this.loyaltyRewardsForm.get('amount').value,
              "applicableCarriers": _selectedRow.applicableCarriers,
              "applicableCountries": _countries,
              "codeGroup": this.loyaltyRewardsForm.get('codeGroup').value,
              "tier": this.loyaltyRewardsForm.get('tier').value,
              "createdBy": _selectedRow.createdBy,
              "createdDttm": _selectedRow.createdDttm,
              "loyaltyConfigStatus": _selectedRow.loyaltyConfigStatus,
              "loyaltyId": _selectedRow.loyaltyId,
              "loyaltyName": _selectedRow.loyaltyName,
              "pointsAccumulated": this.loyaltyRewardsForm.get('points').value,
              "updatedBy": _selectedRow.updatedBy,
              "updatedDttm": _selectedRow.updatedDttm
            }

            this.promotionService.updateLoyaltyRewardsConfig(params).subscribe(
              res => {
                if (res['responseStatus'] == 'Success' && res['httpcode'] == 200) {

                  this.toastrService.success('Updated Successfully', 'Success', {
                    timeOut: 3000,
                  });
                  this.getLoyaltyRewardsData();
                }
              }
            )
            this.return();

          }
          return

          //;
        }
      })

      return
    }
    let _countries: any = Array();
    let _countriesfrom: any = Array();

    this.countryControl.value.forEach(element => {

      if (element != 0) {
        if (this.selectedcountriesList.indexOf(element) !== -1) {
          _countriesfrom.push(element)
        }
        _countries.push(element)

      }
    });
    if (_countriesfrom.length > 0) {
      this.toastrService.error('Loyalty Rewards are already configured for Countries below:  ' + _countriesfrom, 'Error', {
        timeOut: 3000,
      });
      return;
    }

    let params =
    {
      "amountOfRecharge": this.loyaltyRewardsForm.get('amount').value,
      "applicableCountries": _countries,
      "codeGroup": this.loyaltyRewardsForm.get('codeGroup').value,
      "tier": this.loyaltyRewardsForm.get('tier').value,
      "pointsAccumulated": this.loyaltyRewardsForm.get('points').value,
    }
    this.promotionService.addLoyaltyRewardsConfig(params).subscribe(
      res => {
        if (res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success') {
          this.getLoyaltyRewardsData();
          this.toastrService.success('Added loyalty rewards  successfully', 'Success', {
            timeOut: 3000,
          });
        }

      }
    )
    this.return()
  }

  getLoyaltyRewardsData() {
    this.promotionService.getAllLoyaltyRewards().subscribe(res => {

      this.loyalityRewardsData = res['data'];
      this.gridApi.refreshCells();

    });
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    this.return()

  }
  tosslePerOne(all) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.countryControl.value.length == this.countriesList.length)
      this.allSelected.select();
  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      //;
      //;
      //;
      //
      this.countryControl.patchValue([...this.countriesList.map(item => item), 0]);
      //
    } else {
      this.countryControl.patchValue([]);
    }
  }

  getCountryNames(e) {
    let codegroup = this.loyaltyRewardsForm.get('codeGroup').value;
    let tier = this.loyaltyRewardsForm.get('tier').value;
    this.promotionService.getCountryNames(codegroup, tier).subscribe(res => {
      let resData: any = res;
      this.selectedcountriesList = [];
      if (resData.httpcode == 200) {
        resData = resData.data;
        resData.forEach(element => {
          this.selectedcountriesList.push(element);
        });
        //;
      }
    })
  }
}
